import PromotionHeaderImage1 from '../../assets/promotion_header_image1.png';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { SubH1 } from '../../common/common-text';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';

const PromotionHeaderSection = () => {
  const { horizontal: padding } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const { isMobile } = useDeviceType();

  return (
    <VerticalLayout
      style={{
        background: '#707176',
        width: '100%',
        ...(!isMobile ? { aspectRatio: '1920 / 600' } : {}),
      }}>
      <FrameLayout>
        <img
          src={PromotionHeaderImage1}
          style={{
            display: 'block',
            width: '100%',
            height: isMobile ? '290px' : 'auto',
            objectFit: isMobile ? 'cover' : 'unset',
            objectPosition: 'center',
          }}
        />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? 26 : `${pxToRem(70)}`,
            left: padding,
          }}
        >
          Media
        </SubH1>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default PromotionHeaderSection;
